import React from 'react'
import { Menu, Disclosure } from '@headlessui/react'
import { Link, useLocation } from 'react-router-dom'

import ChevronDownIcon from '../../../../assets/icons/chevron-down.svg?react'
import PlusIcon from '../../../../assets/icons/plus.svg?react'
import MinusIcon from '../../../../assets/icons/minus.svg?react'
import useCategories from '../../../../hocs/content/useCategories'
import { useI18N } from '../../../../libraries/i18n/hook'

const CONTENT_PATH = '/content'
type Props = { label: string }
const MenuDropdown: React.FC<Props> = ({ label }) => {
  const { t } = useI18N()
  const { data, isLoading, error } = useCategories()
  const location = useLocation()
  if(isLoading) return <div>{label}</div>
  if(error) return <div>Error al cargar las categorías.</div>
  const getLabel = (open?: boolean) => {
    const classes = open ? 'transform rotate-180' : ''
    return (
      <div className='inline-flex items-center w-full text-black'>
        {label}
        <div className='block sm:hidden'>
          { open
            ? <MinusIcon className='ml-1 h-4 w-4 hover:text-deep-green' aria-hidden />
            : <PlusIcon className='ml-1 h-4 w-4 hover:text-deep-green' aria-hidden />
          }
        </div>
        <ChevronDownIcon
          className={`${classes} hidden mt-0.5 ml-1 sm:block h-4 w-4 hover:text-deep-green`}
          aria-hidden
        />
      </div>
    )
  }

  const isActive = location.pathname.startsWith(CONTENT_PATH)
  return (
    <>
      <Menu as='div' className={`${isActive ? 'menu-dropdown-active' : 'menu-dropdown'} hidden md:block relative text-left`}>
        {({ open }) => (
          <>
            <Menu.Button>
              {getLabel(open)}
            </Menu.Button>
            <Menu.Items className='z-50 absolute left-0 mt-4 w-64 p-4 rounded-lg origin-top-right bg-white shadow-lg focus:outline-none'>
              <Menu.Item>
                <Link tabIndex={-1} to={CONTENT_PATH} className='border-b border-solid border-b-deep-green-200 rounded-b-none text-black hover:bg-deep-green/5 flex w-full items-center rounded-md text-xs sm:text-sm pb-4' role='menuitem'>
                  <span className='pb-1'>{t('content.categories.all')}</span>
                </Link>
              </Menu.Item>
              {data?.map((cat) => (
                <Menu.Item key={cat.name}>
                  <Link tabIndex={-1} to={`${CONTENT_PATH}?mainCategory=${cat.id}`} className='text-black hover:bg-deep-green/5 group flex w-full items-center rounded-md p-3 my-2 text-xs sm:text-sm' role='menuitem'>
                    {cat.name}
                  </Link>
                </Menu.Item>
              ))}
            </Menu.Items>
          </>
        )}
      </Menu>
      <div className={`${isActive ? 'menu-dropdown-active' : 'menu-dropdown'} block md:hidden focus:outline-none`}>
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button>
                {getLabel(open)}
              </Disclosure.Button>
              <Disclosure.Panel className='text-gray-500 mt-1 bg-white w-96'>
                  <Link tabIndex={-1} to={CONTENT_PATH} className='border-b border-solid border-b-deep-green-200 rounded-b-none text-black hover:bg-deep-green/5 flex w-full items-center rounded-md text-xs sm:text-sm' role='menuitem'>
                  <span className='pb-1'>{t('content.categories.all')}</span>
                </Link>
                {data?.map((cat) => (
                  <div key={cat.slug}>
                    <Link
                      tabIndex={-1}
                      to={`${CONTENT_PATH}?mainCategory=${cat.id}`}
                      className='group flex w-full items-center rounded-md pl-3 py-3 px-2 text-deep-green'
                    >
                      {cat.name}
                    </Link>
                  </div>
                ))}
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      </div>
    </>
  )
}

export default MenuDropdown
